// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3K5tp","additionalInfo":"AgreementModal_additionalInfo__2TXmn"};